import React, {useEffect} from "react";
import * as BookPageHelpers from './helpers.js';
import * as Helpers from '../helpers.mjs';
import { useElasticData } from "./DataContext.js";
import {isAdvancedOrLibraryUser} from "../helpers.mjs";
import { currency } from "../helpers.mjs";

const OtherEditions = ({}) => {
    
    let styles = {
        backgroundColor: "transparent"
    }

    let { bindings, broadbindings, altEditions } = useElasticData();

    // Book page html
    useEffect(() => {

            // Load product data
            // Cleaning up
            // return () => {
                
            // };
        }, []
    );

    const getEditionFormat = (ae) => {
        var format = "";
        if (ae.binding && bindings[ae.binding] == "Board book" || bindings[ae.binding] == "Board") {
            format = "Board book";
        } else if (ae.binding && bindings[ae.binding] == "Spiral") {
            format = "Spiral bound";
        } else if (ae.broadBinding && broadbindings[ae.broadBinding] != "Other") {
            format = broadbindings[ae.broadBinding];
        } else if (ae.binding) {
            format = bindings[ae.binding];
        }
        return format;
    }

    const getAltAdditionsByType = () => {
        let editions = [];

        editions["valid"] = [];
        editions["display"] = [];
        editions["counts"] = [];
        editions["eanList"] = [];

        if (isAdvancedOrLibraryUser()) {
            altEditions.forEach(ae => {
                if ((!ae.reportCode || ae.reportCode != 'NP')) {
                    switch (true) {
                        case ae.binding == "HB":
                        case ae.binding == "PB":
                        case ae.binding == "BD":
                        case ae.broadBinding == "O":
                            editions["display"].push(ae);
                            break;
                    }

                    editions["valid"].push(ae);
                    editions["eanList"].push(ae.isbn);
                }
            });
        } else {
            altEditions.forEach(ae => {
                if (!ae.reportCode) {
                    switch (true) {
                        case ae.binding == "HB":
                        case ae.binding == "PB":
                        case ae.binding == "BD":
                        case ae.broadBinding == "O":
                            editions["display"].push(ae);
                            break;
                    }

                    editions["valid"].push(ae);
                }
            });
        }

        editions["counts"]["total"] = altEditions.length;
        editions["counts"]["valid"] = editions["valid"].length;
        editions["counts"]["display"] = editions["display"].length;
        editions["counts"]["total>display"] = altEditions.length > editions["display"].length;
        
        return editions;
    }

    return (
        <>
            {altEditions.length > 0 && <table id="availableEditions" cellSpacing='0' cellPadding='0'>
                <thead>
                    <tr style={styles}><th colSpan="3">{`Other edition${altEditions.length > 1 ? 's' : ''}`}</th></tr>
                </thead>
                <tbody>
                    {altEditions.map(ae => <tr key={ae.id} className="altEditionItem" ean={ae.isbn}>
                        <td><a>{getEditionFormat(ae)}</a></td>
                        <td>{ae.pubDate && new Intl.DateTimeFormat('en-GB', { dateStyle: 'medium' }).format(new Date(ae.pubDate.replace(/-/g, "/")))}</td>
                        <td align='right'>{`${currency(ae.price)}`}
                            <div id="stolenHoverOver">
                                <div className="columnsHoover">
                                    <img src={BookPageHelpers.getBookImageLinks(ae.isbn).cover} onError={(e) => {Helpers.handleImageError(e)}}/>
                                    <p className="editionTitle">{Helpers.decodeHTML(`${ae.title}${ae.subtitle ? `: ${ae.subtitle}` : ''}`)}</p>
                                </div>
                            </div>
                        </td>
                    </tr>)}
                </tbody>
            </table>}
            {getAltAdditionsByType["total>display"] && <a href={`/search-results?isbnList=${getAltAdditionsByType["eanList"].join(',')}`}>Browse all {getAltAdditionsByType["counts"]["total"]} related editions</a> }
        </>
    );
}

export default OtherEditions;